module.exports = __webpack_public_path__ + "img/pad13.6e9900c1.png";